import useTranslation from '@space-core/hooks/useTranslation'
import type { GetSessionsResponse } from '@space-shell/common/services/mentorship/types'

import { Navigation, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import { swiperProps } from './constants'

import * as S from './styles'

import { SessionCard } from '../sessionCard'

export type MentorshipCarouselProps = {
  sessions: GetSessionsResponse[]
}

const MentorshipCarousel = ({ sessions }: MentorshipCarouselProps) => {
  const { t } = useTranslation()

  return (
    <S.ContainerCarousel>
      <h2 className='_text-3 _text-gray-900 _px-4 _px-md-10 _mb-2'>{t('mentorship.title')}</h2>
      <S.Wrapper className='_position-relative _mb-8'>
        <Swiper {...swiperProps} modules={[Pagination, Navigation]}>
          {sessions?.map((session, index) => (
            <SwiperSlide key={session.id} virtualIndex={index}>
              <SessionCard
                key={index}
                calendarExternalName={session.calendarExternalName}
                link={session.link}
                utcStartAt={session.utcStartAt}
                utcEndAt={session.utcEndAt}
                calendarExternalThumbnail={session.calendarExternalThumbnail}
                productName={session.productName}
              />
            </SwiperSlide>
          ))}

          <S.PreventHover $direction='prev' />
          <S.PreventHover $direction='next' />
        </Swiper>
      </S.Wrapper>
    </S.ContainerCarousel>
  )
}

export default MentorshipCarousel
